<template>
  <Teleport to="body">
    <Message/>
    <LoadingScreen v-model="loading"/>
    <Transition name="fade">
      <div class="umoney" v-show="show" :class="{'umoney_whitebg': step > 1}">
        <div class="wrapper-section">
          <Backlink :active="step > 1" class="umoney__backlink"/>
        </div>
        <div class="umoney__stepwindow" :style="{'transform':`translateX(${(step - 1) * 100 * (-1)}%)`}">
          <Step1 />
          <Step2 />
          <Step3 />
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import Backlink from './components/Backlink.vue'
import { mapState, mapGetters } from 'vuex'
import Step1 from './components/Step1.vue'
import Step2 from './components/Step2.vue'
import Step3 from './components/Step3.vue'
import LoadingScreen from './components/LoadingScreen.vue'
import Message from './components/Message.vue'
export default {
  name: 'Umoney',
  components: { Backlink, Step1, Step2, Step3, LoadingScreen, Message },
  data: ()=>({
    actions: {
      show: false
    }
  }),
  created(){
    document.querySelectorAll('.callform').forEach(btn=>{
      btn.addEventListener('click', (e)=>{
        e.preventDefault()
        if (!this.actions.show) {
          this.actions.show = true
          this.$store.dispatch('callAction','show')
        }
        this.$store.commit('setShow', true)
      })
    })
  },
  computed: {
    ...mapState(['step','show']),
    ...mapGetters(['loading'])
  }
}
</script>

<style lang="sass">
.fade-enter-from,.fade-leave-to, .fastfade-enter-from,.fastfade-leave-to
  opacity: 0
  pointer-events: none
.fastfade-enter-active,.fastfade-leave-active
  transition: opacity .2s ease-out
.fade-enter-active,.fade-leave-active
  transition: background .5s ease, opacity .4s ease-out
html
  line-height: 1.15
  -webkit-text-size-adjust: 100%
body
  margin: 0

.umoney 
  --headeroffset: 79px
  @include for-mob
    --headeroffset: 64px
  position: fixed
  z-index: 1000000
  top: var(--headeroffset)
  left: 0
  width: 100%
  height: calc(100% - var(--headeroffset))  
  overflow-x: hidden
  overflow-y: auto
  font-family: globalvars.$font6
  letter-spacing: globalvars.$onespacing
  color: colors.$gray5
  background: colors.$anothersilver
  transition: background .5s ease, opacity .4s ease-out
  &_whitebg
    background: colors.$mainbg
  img, svg
    display: block
  &__backlink 
    margin-top: 38px
  &__stepwindow
    display: flex
    width: 100%
    max-width: 100%
    transition: transform .5s ease  
    >*
      width: 100%
      min-width: 100%
      max-width: 100%
      overflow: hidden
legend
  box-sizing: border-box
  color: inherit
  display: table
  max-width: 100%
  padding: 0
  white-space: normal
a
  text-decoration: none
  color: inherit
button, input, optgroup, select, textarea
  font-family: inherit
  font-size: 100%
  line-height: 1.15
  margin: 0
  color: inherit
button, input
  overflow: visible
button, select
  text-transform: none
button, [type="button"], [type="submit"]
  -webkit-appearance: button
button::-moz-focus-inner, [type="button"]::-moz-focus-inner, [type="submit"]::-moz-focus-inner
  border-style: none
  padding: 0
button:-moz-focusring, [type="button"]:-moz-focusring, [type="submit"]:-moz-focusring
  outline: 1px dotted ButtonText
[type="number"]
  &::-webkit-inner-spin-button, &::-webkit-outer-spin-button
    height: auto

.icons
  position: absolute
*, *::after, *::before
  box-sizing: border-box
ul
  &, li
    padding: 0
    margin: 0
    list-style-type: none
button, [type='submit']
  background: none
  color: inherit
  border: none
  padding: 0
  font: inherit
  cursor: pointer
  outline: inherit
p
  margin: 0
</style>
